import { useState } from "react";
import {
  MENTORUM_DUYGULARI,
  MENTORUM_DUYGU_ETIKETI,
  duyguKaydiSemasi,
  type MentorumDuygu as Duygu,
} from "@koclukpanel/contracts";
import { Buton, Kart, cn } from "@koclukpanel/ui";
import { api } from "./api";
import { mentorumHataMetni, mentorumKapiHatasi } from "./Mentorum";

export function MentorumDuygu({ onKapiHatasi }: { onKapiHatasi?: (hata: unknown) => void }) {
  const [duygu, setDuygu] = useState<Duygu | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [kaydedildi, setKaydedildi] = useState(false);
  const [islem, setIslem] = useState(false);
  const kaydet = async () => {
    if (!duygu) return;
    setIslem(true);
    setHata(null);
    try {
      // F-MNT-10 — gün sınırını telefonun saati değil sunucunun 409 yanıtı belirler.
      await api("/mentorum/duygu", {
        yontem: "POST",
        govde: duyguKaydiSemasi.parse({ mood: duygu }),
      });
      setKaydedildi(true);
      setDuygu(null);
    } catch (sorun) {
      setHata(mentorumHataMetni(sorun));
      if (mentorumKapiHatasi(sorun)) onKapiHatasi?.(sorun);
    } finally {
      setIslem(false);
    }
  };
  return (
    <Kart baslik="Bugün nasıl hissediyorsun?" className="min-w-0">
      {kaydedildi ? (
        <p role="status">Bugünkü duygu kaydın alındı.</p>
      ) : (
        <>
          <fieldset disabled={islem} className="min-w-0">
            <legend className="mb-3">Bugünkü duygunu seç</legend>
            <div className="grid min-w-0 grid-cols-2 gap-2">
              {MENTORUM_DUYGULARI.map((secenek) => (
                <button
                  key={secenek}
                  type="button"
                  aria-pressed={duygu === secenek}
                  onClick={() => setDuygu(secenek)}
                  className={cn(
                    "min-h-dokunma rounded-alan border px-3 py-2 text-sm",
                    duygu === secenek
                      ? "border-marka-600 bg-marka-50 text-marka-700"
                      : "border-notr-300 text-notr-800",
                  )}
                >
                  {MENTORUM_DUYGU_ETIKETI[secenek]}
                </button>
              ))}
            </div>
          </fieldset>
          {hata && (
            <p role="alert" className="mt-3">
              {hata}
            </p>
          )}
          <Buton className="mt-4 w-full" disabled={!duygu || islem} onClick={() => void kaydet()}>
            Duygumu kaydet
          </Buton>
        </>
      )}
    </Kart>
  );
}
